import { differenceInMonths } from 'date-fns';
import { ContainsSearchInfo } from '../../legacy/transcepta-common/utils/documentSearch';

export function shouldShowDateRangeError(startDate: Date, endDate: Date, containsSearchInfo: ContainsSearchInfo) {
    const timeDiff = differenceInMonths(endDate, startDate);
    return timeDiff > 6 && containsSearchInfo && containsSearchInfo.mode === 'Contains';
}
